import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';

import { i18n as I18n } from 'utils/i18n';

const LoginActionPanel = ({
  heading,
  showResendConfirmationLink,
  showResetPasswordLink,
  showRegisterLink,
  showBackToLoginLink,
  children,
}) => {
  return (
    <div
      className="login"
      style={{ backgroundImage: "url('/images/banner-login.jpg')" }}
      data-cy="loginActionPanel"
    >
      <div className="login__content">
        <h1 className="login__heading">{heading}</h1>
        <h1 className="login__mobile-heading">{heading}</h1>

        <div className="field">
          {children}

          <div className="login__links">
            {showResendConfirmationLink && (
              <p>
                <Link href={I18n.t('navigation.resend_confirmation_email.url')}>
                  <a>{I18n.t('sign_in.resend_confirmation_link')}</a>
                </Link>
              </p>
            )}

            {showResetPasswordLink && (
              <p>
                <Link href={I18n.t('navigation.forgotten_password.url')}>
                  <a>{I18n.t('sign_in.forgotten_your_password')}</a>
                </Link>
              </p>
            )}

            {showBackToLoginLink && (
              <p>
                <Link href={I18n.t('navigation.sign_in.url')}>
                  <a>{I18n.t('sign_in.back_link')}</a>
                </Link>
              </p>
            )}

            {showRegisterLink && (
              <p>
                {I18n.t('sign_in.dont_have_an_account')}
                &nbsp;
                <Link href={I18n.t('navigation.register.url')}>
                  <a>{I18n.t('sign_in.register_here')}</a>
                </Link>
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

LoginActionPanel.propTypes = {
  heading: PropTypes.string.isRequired,
  showResendConfirmationLink: PropTypes.bool,
  showResetPasswordLink: PropTypes.bool,
  showRegisterLink: PropTypes.bool,
  showBackToLoginLink: PropTypes.bool,
  children: PropTypes.node,
};

LoginActionPanel.defaultProps = {
  showResendConfirmationLink: true,
  showResetPasswordLink: true,
  showRegisterLink: true,
  showBackToLoginLink: true,
};

export default LoginActionPanel;
